export const currentStepLocalStorageKey = 'yearlyAssessmentCurrentStep'
export const formValuesLocalStorageKey = 'yearlyAssessmentFormValues'

export const makeLocalStorageKey = (key: string, locationId: string) =>
  `${key}-${locationId}`
